export enum MutationTypes {
  SET_DAY_MENU = "SET_DAY_MENU",
  SET_SELECT_FILTERS = "SET_SELECT_FILTERS",
  SET_SELECT_WINDOW = "SET_SELECT_WINDOW",
  SET_SEARCH = "SET_SEARCH",
  SET_LANGUAGE = "SET_LANGUAGE,",
}
